import script from "./LiveChatPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveChatPopup.vue?vue&type=script&setup=true&lang=js"

import "./LiveChatPopup.vue?vue&type=style&index=0&id=260ae8f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-260ae8f6"]])

export default __exports__